// extracted by mini-css-extract-plugin
export default {"wrapper":"StatsWidget_wrapper__bK2ta"};